package com.eladfinish.bible.contest.ui.components.buttons

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.graphics.vector.rememberVectorPainter
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.colorPrimaryDark
import com.eladfinish.bible.contest.common.gender.HebrewGender
import com.eladfinish.bible.contest.common.gender.personalizeGender
import com.eladfinish.bible.contest.ic_button_drag
import com.eladfinish.bible.contest.screens.main.data.ButtonIcon
import com.eladfinish.bible.contest.strokeColor
import dev.icerock.moko.resources.StringResource
import dev.icerock.moko.resources.compose.colorResource
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource

@Composable
fun DraggableIconTextButton(
    modifier: Modifier = Modifier,
    stringResource: StringResource,
    icon: ButtonIcon,
    hebrewGender: HebrewGender,
    fontSize: TextUnit = 18.sp,
) {
    Box(
        modifier = modifier
            .background(colorResource(resource = SharedRes.colors.colorPrimaryDark))
            .fillMaxWidth()
            .border(
                width = 1.dp,
                color = colorResource(resource = SharedRes.colors.strokeColor),
                shape = RoundedCornerShape(12.dp),
            ),
        contentAlignment = Alignment.TopEnd,
    ) {
        Image(
            painter = painterResource(SharedRes.images.ic_button_drag),
            contentDescription = null,
            modifier = Modifier.size(48.dp),
            colorFilter = ColorFilter.tint(Color.White),
        )

        Column(
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center,
            modifier = Modifier
                .heightIn(min = 60.dp)
                .fillMaxWidth()
        ) {
            Image(
                painter = when (icon) {
                    is ButtonIcon.Resource -> painterResource(icon.imageResource)
                    is ButtonIcon.Vector -> rememberVectorPainter(icon.imageVector)
                },
                contentDescription = null,
                modifier = Modifier.size(48.dp),
                colorFilter = ColorFilter.tint(Color.White),
            )
            Text(
                text = stringResource(resource = stringResource).personalizeGender(hebrewGender),
                fontSize = fontSize,
                style = MaterialTheme.typography.labelLarge,
                textAlign = TextAlign.Center,
                modifier = Modifier.padding(top = 2.dp),
                color = Color.White,
            )
        }
    }
}
